
 export function buildCoFAUrl(
  baseURL,
  materialNumber,
  batch
) {
  return `${baseURL}/tdhome/search-result?size=n_100_n
&filters%5B0%5D%5Bfield%5D=language
&filters%5B0%5D%5Bvalues%5D%5B0%5D=English
&filters%5B0%5D%5Bvalues%5D%5B1%5D=Multiple%20Languages
&filters%5B0%5D%5Btype%5D=any
&filters%5B1%5D%5Bfield%5D=audience
&filters%5B1%5D%5Bvalues%5D%5B0%5D=Public
&filters%5B1%5D%5Bvalues%5D%5B1%5D=Internal
&filters%5B1%5D%5Bvalues%5D%5B2%5D=Authenticated
&filters%5B1%5D%5Btype%5D=any
&filters%5B2%5D%5Bfield%5D=regioncountrylist
&filters%5B2%5D%5Bvalues%5D%5B0%5D=United%20States
&filters%5B2%5D%5Btype%5D=any
&filters%5B3%5D%5Bfield%5D=expirationdate
&filters%5B3%5D%5Bvalues%5D%5B0%5D%5Bfrom%5D=2026-03-11T00%3A00%3A00.000Z
&filters%5B3%5D%5Bvalues%5D%5B0%5D%5Bto%5D=9999-12-31T23%3A59%3A59.000Z
&filters%5B3%5D%5Btype%5D=any
&filters%5B4%5D%5Bfield%5D=document_classification_subcategory
&filters%5B4%5D%5Bvalues%5D%5B0%5D=Certificate%20of%20Analysis
&filters%5B4%5D%5Btype%5D=any
&filters%5B5%5D%5Bfield%5D=catalognumberlist
&filters%5B5%5D%5Bvalues%5D%5B0%5D=${materialNumber}
&filters%5B5%5D%5Btype%5D=any
&filters%5B6%5D%5Bfield%5D=lot
&filters%5B6%5D%5Bvalues%5D%5B0%5D=${batch}
&filters%5B6%5D%5Btype%5D=any&isauthenticated=internal`;
}

export function buildDocUrl(
  baseURL,
  materialNumber,
) {
  return `${baseURL}/tdhome/search-result?size=n_100_n
&filters%5B0%5D%5Bfield%5D=language
&filters%5B0%5D%5Bvalues%5D%5B0%5D=English
&filters%5B0%5D%5Bvalues%5D%5B1%5D=Multiple%20Languages
&filters%5B0%5D%5Btype%5D=any
&filters%5B1%5D%5Bfield%5D=audience
&filters%5B1%5D%5Bvalues%5D%5B0%5D=Public
&filters%5B1%5D%5Bvalues%5D%5B1%5D=Internal
&filters%5B1%5D%5Bvalues%5D%5B2%5D=Authenticated
&filters%5B1%5D%5Btype%5D=any
&filters%5B2%5D%5Bfield%5D=regioncountrylist
&filters%5B2%5D%5Bvalues%5D%5B0%5D=United%20States
&filters%5B2%5D%5Btype%5D=any
&filters%5B3%5D%5Bfield%5D=expirationdate
&filters%5B3%5D%5Bvalues%5D%5B0%5D%5Bfrom%5D=2026-03-11T00%3A00%3A00.000Z
&filters%5B3%5D%5Bvalues%5D%5B0%5D%5Bto%5D=9999-12-31T23%3A59%3A59.000Z
&filters%5B3%5D%5Btype%5D=any
&filters%5B4%5D%5Bfield%5D=document_classification_subcategory
&filters%5B4%5D%5Bvalues%5D%5B0%5D=Declaration%20of%20Conformity
&filters%5B4%5D%5Btype%5D=any
&filters%5B5%5D%5Bfield%5D=catalognumberlist
&filters%5B5%5D%5Bvalues%5D%5B0%5D=${materialNumber}
&filters%5B5%5D%5Btype%5D=any&isauthenticated=internal`;
}
